// src/components/Collapsible.jsx
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

function Collapsible({ title, children, defaultExpanded = false }) {
  const [isOpen, setIsOpen] = useState(defaultExpanded);

  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-md">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-3 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
        aria-expanded={isOpen}
      >
        <span className="font-medium text-gray-900 dark:text-white">{title}</span>
        <ChevronDown
          className={`w-5 h-5 text-gray-500 dark:text-gray-400 transition-transform ${
            isOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>
      {isOpen && (
        <div className="p-3 border-t border-gray-200 dark:border-gray-700 overflow-auto max-h-none transition-all whitespace-pre-wrap break-words">
          {children}
        </div>
      )}
    </div>
  );
}

export default Collapsible;












